import { store } from "../../../store";
import { resetLocalStorage } from "../../../helpers/misc";
import { resetCsrf } from "./csrf";
import swal from "sweetalert2";

export function clearAuthState(): void {
  resetCsrf();
  resetLocalStorage();
  store.commit("setAuthenticated", false);
  store.commit("setUser", {});
  swal.close();
  $(".pswp").remove();
}
